'use client';
'use strict';

var React = require('react');
var cx = require('clsx');
require('@mantine/hooks');
require('../../../core/MantineProvider/Mantine.context.cjs');
require('../../../core/MantineProvider/default-theme.cjs');
require('../../../core/MantineProvider/MantineProvider.cjs');
require('../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.cjs');
var Box = require('../../../core/Box/Box.cjs');
require('../../../core/DirectionProvider/DirectionProvider.cjs');
var Loader_module = require('../Loader.module.css.cjs');

const Oval = React.forwardRef(({ className, ...others }, ref) => /* @__PURE__ */ React.createElement(Box.Box, { component: "span", className: cx(Loader_module.ovalLoader, className), ...others, ref }));

exports.Oval = Oval;
//# sourceMappingURL=Oval.cjs.map
